import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation editUserRole(
      $roleId: ID!
      $roleName: String!
      $data: JSONString!
    ) {
      changeUserRole(
        roleId: $roleId
        ssoRole: { roleName: $roleName, data: $data }
      ) {
        id
        user
        name
        data
      }
    }
  `,
  mutationName: "editUserRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/ssoUserRole/editUserRole.js